module.exports = __webpack_public_path__ + "static/media/Save lagu anak.2557aada.jpeg";